export default __webpack_public_path__ + "static/media/sports-mania.83deaeda.png";